import share from "./share.vue";

let Plugin = {},
  vueClass = Vue.extend(share),
  vueInstance;

Plugin.install = function(Vue, opt) {
  opt.root.share = function() {
    // if (!vueInstance) {
      let el = document.createElement("div");
      document.querySelector("body").appendChild(el);

      vueInstance = new vueClass({
        el: el,
        router: opt.router,
      });
    // }

    return vueInstance.show(...arguments);
  };
};

export default Plugin;
